import { render, staticRenderFns } from "./product.vue?vue&type=template&id=1c2ff463&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=1c2ff463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2ff463",
  null
  
)

export default component.exports